export const works = [
  {
    id: "work-1",
    title: "深夜的诱惑",
    category: "movie",
    year: 2026,
    role: "女主角",
    description: "风间由美在本片中饰演一位神秘而优雅的成熟女性，其精湛的演技将角色的复杂内心世界刻画得淋漓尽致。影片以其独特的叙事手法和细腻的情感表达，在观众中引起强烈共鸣。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20sophisticated%20evening%20gown%2C%20soft%20cinematic%20lighting%2C%20film%20poster%20aesthetic%2C%20warm%20golden%20tones%2C%20artistic%20portrait%20photography%20with%20dramatic%20shadows%2C%20minimalist%20background&width=600&height=800&seq=work-1&orientation=portrait",
    rating: 4.5,
    director: "山田太郎",
    releaseDate: "2026-03-15",
  },
  {
    id: "work-2",
    title: "东京恋语",
    category: "tv",
    year: 2025,
    role: "女二号",
    description: "一部温暖人心的都市爱情剧。风间由美饰演的角色以其独特的魅力与成熟的演技，为整部剧集增添了丰富的戏剧张力，成为观众最喜爱的角色之一。",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20modern%20urban%20setting%2C%20warm%20city%20lights%20background%2C%20elegant%20style%2C%20romantic%20drama%20poster%20aesthetic%2C%20soft%20evening%20atmosphere%2C%20professional%20photography&width=600&height=800&seq=work-2&orientation=portrait",
    rating: 4.2,
    director: "佐藤花子",
    releaseDate: "2025-10-01",
  },
  {
    id: "work-3",
    title: "蝶影重重",
    category: "movie",
    year: 2025,
    role: "特别出演",
    description: "一部紧张刺激的悬疑片。风间由美在片中展现了不同于以往的演技面貌，其饰演的神秘角色贯穿全片，成为推动剧情发展的关键线索。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20elegant%20Japanese%20woman%20in%20shadow%2C%20noir%20film%20aesthetic%2C%20dramatic%20lighting%2C%20suspense%20thriller%20atmosphere%2C%20dark%20sophisticated%20portrait%2C%20cinematic%20photography&width=600&height=800&seq=work-3&orientation=portrait",
    rating: 4.7,
    director: "中村健一",
    releaseDate: "2025-06-20",
  },
  {
    id: "work-4",
    title: "樱花下的约定",
    category: "stage",
    year: 2024,
    role: "女主角",
    description: "风间由美首次挑战舞台剧，便获得业界一致好评。她在舞台上的表现力令人惊叹，将角色的喜怒哀乐通过细腻的肢体语言和富有感染力的台词完美呈现。",
    image: "https://readdy.ai/api/search-image?query=Japanese%20woman%20on%20theater%20stage%2C%20dramatic%20spotlight%2C%20cherry%20blossom%20theme%2C%20elegant%20costume%2C%20stage%20performance%20photography%2C%20warm%20theatrical%20lighting%2C%20artistic%20composition&width=600&height=800&seq=work-4&orientation=portrait",
    rating: 4.8,
    director: "田中雅美",
    releaseDate: "2024-09-10",
  },
  {
    id: "work-5",
    title: "笑颜大冒险",
    category: "variety",
    year: 2026,
    role: "常驻嘉宾",
    description: "风间由美在综艺节目中展现了与银幕形象截然不同的活泼一面，其自然的综艺感和真诚的笑容赢得了大量观众的好感，成为节目中不可或缺的亮点。",
    image: "https://readdy.ai/api/search-image?query=Cheerful%20Japanese%20woman%20in%20colorful%20variety%20show%20setting%2C%20bright%20studio%20lights%2C%20happy%20expression%2C%20casual%20elegant%20style%2C%20entertainment%20show%20atmosphere%2C%20warm%20vibrant%20colors&width=600&height=800&seq=work-5&orientation=portrait",
    rating: 4.3,
    director: "娱乐频道制作组",
    releaseDate: "2026-01-05",
  },
  {
    id: "work-6",
    title: "月光之城的秘密",
    category: "movie",
    year: 2024,
    role: "女主角",
    description: "一部充满奇幻色彩的电影。风间由美在片中饰演一位拥有神秘力量的女性，她用极具层次感的表演将角色的内心挣扎与成长历程展现得令人动容。",
    image: "https://readdy.ai/api/search-image?query=Mystical%20Japanese%20woman%20in%20moonlight%2C%20fantasy%20film%20aesthetic%2C%20ethereal%20atmosphere%2C%20elegant%20flowing%20dress%2C%20magical%20warm%20glow%2C%20cinematic%20portrait%20photography&width=600&height=800&seq=work-6&orientation=portrait",
    rating: 4.6,
    director: "小林光",
    releaseDate: "2024-12-01",
  },
  {
    id: "work-7",
    title: "都市夜话",
    category: "tv",
    year: 2024,
    role: "女主角",
    description: "一部探讨现代都市女性生活的电视剧。风间由美以其成熟的演技和对角色深刻的理解，塑造了一个真实而立体的职场女性形象，引发了广泛的社会讨论。",
    image: "https://readdy.ai/api/search-image?query=Professional%20Japanese%20woman%20in%20modern%20office%2C%20city%20night%20view%20through%20window%2C%20elegant%20business%20style%2C%20drama%20series%20poster%2C%20sophisticated%20atmosphere%2C%20warm%20interior%20lighting&width=600&height=800&seq=work-7&orientation=portrait",
    rating: 4.4,
    director: "高桥诚",
    releaseDate: "2024-04-05",
  },
  {
    id: "work-8",
    title: "艺能大挑战",
    category: "variety",
    year: 2025,
    role: "特邀嘉宾",
    description: "风间由美作为特邀嘉宾参与了本季综艺节目的录制。她在节目中展现了多才多艺的一面，其幽默感和亲和力让现场气氛热烈，获得了观众的一致好评。",
    image: "https://readdy.ai/api/search-image?query=Japanese%20celebrity%20on%20TV%20game%20show%2C%20bright%20colorful%20studio%2C%20excited%20expression%2C%20entertainment%20photography%2C%20dynamic%20lighting%2C%20warm%20fun%20atmosphere&width=600&height=800&seq=work-8&orientation=portrait",
    rating: 4.1,
    director: "综艺频道制作组",
    releaseDate: "2025-08-15",
  },
  {
    id: "work-9",
    title: "恋之旋律",
    category: "stage",
    year: 2025,
    role: "女主角",
    description: "风间由美再度挑战舞台剧，本次以音乐剧形式呈现。她不仅演技出色，歌唱和舞蹈也令人惊艳，展现了作为全能艺人的实力与魅力。",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20in%20musical%20theater%2C%20dramatic%20stage%20lighting%2C%20elegant%20performance%20costume%2C%20singing%20pose%2C%20theatrical%20photography%2C%20warm%20spotlight%2C%20artistic%20composition&width=600&height=800&seq=work-9&orientation=portrait",
    rating: 4.9,
    director: "渡边纯",
    releaseDate: "2025-03-20",
  },
  {
    id: "work-10",
    title: "夏日烟火",
    category: "movie",
    year: 2023,
    role: "女主角",
    description: "一部令人难忘的青春回忆题材电影。风间由美在片中饰演一位回到故乡的女性，在夏日烟火中重新发现了生活的美好。她的表演细腻而真挚，让无数观众感动落泪。",
    image: "https://readdy.ai/api/search-image?query=Japanese%20woman%20under%20summer%20fireworks%2C%20nostalgic%20atmosphere%2C%20yukata%20traditional%20dress%2C%20warm%20evening%20glow%2C%20romantic%20film%20poster%2C%20beautiful%20scenery%2C%20cinematic%20photography&width=600&height=800&seq=work-10&orientation=portrait",
    rating: 4.5,
    director: "伊藤良子",
    releaseDate: "2023-08-10",
  },
];